import { GlobalStyles } from '@mui/material';
import { useEffect } from 'react';

import { useIsIdle } from '#shared';

export const IdleUXController = () => {
  const isIdle = useIsIdle();

  useEffect(() => {
    const root = document.documentElement;
    if (isIdle) {
      root.setAttribute('data-idle', '');
    } else {
      root.removeAttribute('data-idle');
    }
    return () => root.removeAttribute('data-idle');
  }, [isIdle]);

  return (
    <GlobalStyles
      styles={{
        /* hide cursor everywhere while idle */
        'html[data-idle], html[data-idle] *': {
          cursor: 'none !important',
        },
        /* full-screen shield to kill :hover under it */
        'html[data-idle]::after': {
          content: '""',
          position: 'fixed',
          inset: 0,
          zIndex: 2147483647,
          background: 'transparent',
          pointerEvents: 'auto', // capture hover/click/scroll
          cursor: 'none !important',
        },
      }}
    />
  );
};
